import { render, staticRenderFns } from "./DashboardCurrentMonthSummary.vue?vue&type=template&id=d1d46d52&scoped=true&"
import script from "./DashboardCurrentMonthSummary.vue?vue&type=script&lang=js&"
export * from "./DashboardCurrentMonthSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d46d52",
  null
  
)

export default component.exports